import { createApp } from "vue";
import ApiService from "@/services/apiService";
import RegistrierungDafuerForm from "./RegistrierungDafuerForm.vue";

let registrierungDafuerContainer = document.getElementById("registrierung-dafuer-form");

if(registrierungDafuerContainer) {
    const app= createApp(RegistrierungDafuerForm, { container:registrierungDafuerContainer });
    ApiService.create();
    app.mount(registrierungDafuerContainer);
}

